import { render, staticRenderFns } from "./ModalModel.vue?vue&type=template&id=f930a21e&"
import script from "./ModalModel.vue?vue&type=script&lang=js&"
export * from "./ModalModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports